import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

interface FieldHintProps {
  text: string;
}

export default function FieldHint({ text }: FieldHintProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center text-gray-400 hover:text-gray-600 transition-colors"
          aria-label={text}
        >
          <Info className="w-3.5 h-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-[280px] text-left">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
